import { useEffect, useMemo, useState } from 'react';
import { intelligenceApi } from '../lib/adapter';
import type { IntelligenceOverview } from '../types/contracts';
import { IntelligenceShell } from '../components/IntelligenceShell';
import { KpiStrip } from '../components/KpiStrip';
import { AttentionQueue } from '../components/AttentionQueue';
import { ConversationList } from '../components/ConversationList';
import { AgentStatus } from '../components/AgentStatus';
import { EmptyState, ErrorState, Skeleton } from '../components/states';

export default function CommandCenterPage() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [data, setData] = useState<IntelligenceOverview | null>(null);
  const [query, setQuery] = useState('');

  const load = async () => {
    setLoading(true);
    setError('');
    const r = await intelligenceApi.getOverview();
    setLoading(false);
    if (!r.ok) { setError('message' in r ? r.message : 'حدث خطأ ما'); return; }
    setData(r.data);
  };

  useEffect(() => { void load(); }, []);

  const q = query.trim().toLowerCase();
  const attention = useMemo(() => {
    if (!data) return [];
    if (!q) return data.attention;
    return data.attention.filter((a) =>
      [a.customer_name, a.business, a.excerpt, a.status_label].join(' ').toLowerCase().includes(q));
  }, [data, q]);
  const live = useMemo(() => {
    if (!data) return [];
    if (!q) return data.live;
    return data.live.filter((c) =>
      [c.customer_name, c.business_name, c.last_message].join(' ').toLowerCase().includes(q));
  }, [data, q]);

  const empty = !loading && !error && data && data.attention.length === 0 && data.live.length === 0;

  return (
    <IntelligenceShell notifications={data?.notifications ?? []} onSearch={setQuery} searchValue={query}>
      {loading ? <Skeleton rows={6} /> : null}
      {error ? <ErrorState message={error} onRetry={() => void load()} /> : null}
      {empty ? (
        <EmptyState title="لا يوجد نشاط بعد" body="بمجرد ربط القنوات ستظهر العملاء والمحادثات والمتابعات هنا." />
      ) : null}
      {!loading && !error && data && !empty ? (
        <div className="space-y-5">
          <KpiStrip items={data.kpis} />
          <div className="grid xl:grid-cols-3 gap-4 items-start">
            <div className="xl:col-span-2 space-y-4">
              <AttentionQueue items={attention} />
            </div>
            <AgentStatus agents={data.agents} />
          </div>
          <ConversationList conversations={live} />
        </div>
      ) : null}
    </IntelligenceShell>
  );
}
